import { useEffect, useState } from "react";
import { extractPagesAsImages } from "../services/pdfService";

const renderThumbnailFromService = async (file: File): Promise<string> => {
  const result = await extractPagesAsImages(file);
  const firstPage = result.images[0];
  if (!firstPage?.base64_data) {
    return "";
  }

  return `data:image/${firstPage.format};base64,${firstPage.base64_data}`;
};

export const usePdfThumbnails = (files: File[]): string[] => {
  const [thumbnails, setThumbnails] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;

    if (files.length === 0) {
      setThumbnails([]);
      return () => {
        cancelled = true;
      };
    }

    setThumbnails([]);

    const run = async () => {
      const generated = await Promise.all(
        files.map(async (file) => {
          try {
            return await renderThumbnailFromService(file);
          } catch (error) {
            console.warn(`Thumbnail generation failed for ${file.name}`, error);
            return "";
          }
        })
      );

      if (!cancelled) {
        setThumbnails(generated);
      }
    };

    void run();

    return () => {
      cancelled = true;
    };
  }, [files]);

  return thumbnails;
};
